import React from 'react';

interface LabeledFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
}

/** Form row: label (+ required asterisk), the control, and an optional error line. */
export const LabeledField = ({
  label,
  required,
  error,
  children,
}: LabeledFieldProps) => (
  <div className="tw-flex tw-flex-col tw-gap-[6px]">
    <label className="tw-font-poppins tw-text-[13px] tw-font-medium tw-text-ds-ink-soft">
      {label}
      {required && <sup className="tw-text-ds-danger tw-ml-[2px]">*</sup>}
    </label>
    {children}
    {error && (
      <span className="tw-font-poppins tw-text-[12px] tw-text-ds-danger">
        {error}
      </span>
    )}
  </div>
);
